import React from 'react';
import { useTranslation } from '../../context/LanguageContext';
import { ProgressiveLoader } from './ProgressiveLoader';

// Stats are static structurally; only the labels are translated at render time.
const STATS = [
    { value: '10+',   key: 'stats.years',    delay: 0 },
    { value: '2500+', key: 'stats.patients', delay: 150 },
    { value: '25+',   key: 'stats.services', delay: 300 },
];

/**
 * Home — Stats bar (years experience, patients, services) with staggered fade-in.
 */
export const HomeStatsSection = () => {
    const { t } = useTranslation();

    return (
        <section className="bg-navy py-10 sm:py-12">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 text-center text-white">
                    {STATS.map(({ value, key, delay }) => (
                        <ProgressiveLoader key={key} delay={delay} className="flex flex-col items-center">
                            <span className="text-3xl sm:text-4xl md:text-5xl font-bold text-gold">{value}</span>
                            <span className="text-sm sm:text-base text-gray-300 mt-2 font-medium">{t(key)}</span>
                        </ProgressiveLoader>
                    ))}
                </div>
            </div>
        </section>
    );
};

